/**
 * A first guess for the colour step of a wine nobody has judged yet: the tint its grape usually
 * shows. It only ever proposes a tint inside the colour the wine already has, so it can sharpen
 * the pre-selection but never contradicts the catalogue's colour.
 */
import { HUES_BY_COLOUR, type Hue, type WineColour } from "../scales.js";
import { grapeCodeOf } from "./grapes.js";
import { LOOK_ESTIMATES } from "./lookEstimates.data.js";

/** The tint of the first listed grape we have an estimate for, if it fits `colour`. */
export function estimateHue(grapes: readonly string[], colour: WineColour): Hue | undefined {
  for (const text of grapes) {
    const code = grapeCodeOf(text);
    const hue = code === undefined ? undefined : LOOK_ESTIMATES[code];
    if (hue !== undefined) return HUES_BY_COLOUR[colour].includes(hue) ? hue : undefined;
  }
  return undefined;
}
